import { type Product } from '@/domain/products/types';
import { Suspense } from 'react';

import Content from './Content';

interface ProductPanelHeaderProps {
  detailedProduct: Product;
  onClose?: () => void;
  isProductDetailPage?: boolean;
}

const ProductPanelHeader = ({ detailedProduct, onClose, isProductDetailPage = false }: ProductPanelHeaderProps) => (
  <Suspense>
    <Content detailedProduct={detailedProduct} onClose={onClose} isProductDetailPage={isProductDetailPage} />
  </Suspense>
);

export default ProductPanelHeader;
